import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ab990922"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["src"];
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("Please add Goby official customer service ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" to provide you with accurate service and latest developments.");

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_7 = {
  key: 3
};
const _hoisted_8 = {
  key: 4
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_result = _resolveComponent("el-result");

  return _openBlock(), _createBlock(_component_el_result, {
    icon: "success",
    title: _ctx.$t('Payment successful')
  }, {
    extra: _withCtx(() => [_ctx.oneYuan === '1' && _ctx.lang == 'zh' ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "wt-img",
      src: require('@/assets/img/goby-wechat.jpg')
    }, null, 8, _hoisted_1)) : _createCommentVNode("", true), _ctx.oneYuan === '1' && _ctx.lang == 'zh' ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t("Please add Goby official customer service WeChat to provide you with accurate service and latest developments")), 1)) : _createCommentVNode("", true), _ctx.oneYuan === '1' && _ctx.lang == 'en' ? (_openBlock(), _createElementBlock("p", _hoisted_3, [_createElementVNode("span", null, [_hoisted_4, _createElementVNode("a", {
      href: "#",
      onClick: _cache[0] || (_cache[0] = //@ts-ignore
      (...args) => _ctx.toPage && _ctx.toPage(...args))
    }, "Telegram"), _hoisted_5])])) : _createCommentVNode("", true), _hoisted_6, _ctx.oneYuan === '1' ? (_openBlock(), _createElementBlock("h3", _hoisted_7, [_createElementVNode("a", {
      onClick: _cache[1] || (_cache[1] = //@ts-ignore
      (...args) => _ctx.toLicMan && _ctx.toLicMan(...args))
    }, _toDisplayString(_ctx.$t("License Management")), 1)])) : (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(_ctx.$t("After num second, you will automatically jump to License management", {
      num: _ctx.timeText
    })), 1))]),
    _: 1
  }, 8, ["title"]);
}